<script>
    import Modal from "./Modal.svelte";
    import { createEventDispatcher } from 'svelte';
    import PermissionlessProjectPreview from "../PermissionlessProjectPreview.svelte";
    const dispatch = createEventDispatcher();
    const modalAction = () => {
        dispatch("modalAction")
    }
    export let modalStatus;
</script>

<Modal {modalStatus} on:modalAction={modalAction}>
    <PermissionlessProjectPreview/>
</Modal>